/* eslint-disable @typescript-eslint/no-unused-vars */
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from './config/queryClient'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import App from './App'
import store from './redux/store'
import './scss/index.scss'
import {
  setupArabicDigitInputNormalization,
  setupEnglishNumberInputDisplay,
} from './utils/normalizeInputDigits'

setupArabicDigitInputNormalization()
setupEnglishNumberInputDisplay()


const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

root.render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
      />

      <App />

      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
    </Provider>
  </QueryClientProvider>,
)
